import { Link } from 'react-router-dom'
import { Facebook, Linkedin, Mail, Phone, MapPin } from 'lucide-react'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-primary text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img src="/assets/logos/path110.png" alt="Rudovia Life College" className=" max-w-60" />
            </div>
            <p className="text-gray-300 mb-4">
              Empowering leaders in faith, service, and innovation across Africa and beyond.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/Rudovia" target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/111399087/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-300 hover:text-secondary transition-colors">About Us</Link></li>
              <li><Link to="/programs" className="text-gray-300 hover:text-secondary transition-colors">Programs</Link></li>
              <li><Link to="/admissions" className="text-gray-300 hover:text-secondary transition-colors">Admissions</Link></li>
              <li><Link to="/founders-corner" className="text-gray-300 hover:text-secondary transition-colors">Founder's Corner</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-secondary transition-colors">Testimonials</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-secondary transition-colors">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Programs</h3>
            <ul className="space-y-2">
              <li><Link to="/programs/theology" className="text-gray-300 hover:text-secondary transition-colors">Theology</Link></li>
              <li><Link to="/programs/leadership" className="text-gray-300 hover:text-secondary transition-colors">Leadership</Link></li>
              <li><Link to="/programs/nursing" className="text-gray-300 hover:text-secondary transition-colors">Nursing Diploma</Link></li>
              <li><Link to="/programs/architecture" className="text-gray-300 hover:text-secondary transition-colors">Architecture</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-secondary flex-shrink-0 mt-1" />
                <span className="text-gray-300">Harare, Zimbabwe</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-secondary flex-shrink-0" />
                <a href="tel:+263713667029" className="text-gray-300 hover:text-secondary transition-colors">+263 71 366 7029</a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-secondary flex-shrink-0" />
                <a href="mailto:info@rudovia.ac.zw" className="text-gray-300 hover:text-secondary transition-colors">admin@rudovia.ac.zw</a>
              </li>
            </ul>
            
            <div className="mt-6">
              <h4 className="font-semibold mb-2">Newsletter</h4>
              <form className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 rounded-l-lg text-primary focus:outline-none"
                  aria-label="Email for newsletter"
                />
                <button type="submit" className="bg-secondary hover:bg-orange-600 px-4 py-2 rounded-r-lg transition-colors">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-300 text-sm">
              © {currentYear} Rudovia Life College. All rights reserved.
            </p>
            <div className="flex space-x-4 text-sm">
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Privacy Policy</a>
              <span className="text-gray-600">|</span>
              <a href="#" className="text-gray-300 hover:text-secondary transition-colors">Terms of Service</a>
            </div>
          </div>
          <div className="mt-4 text-center">
            <p className="text-secondary font-semibold text-sm">
              #RudoviaCollege #DoreenSpeaks
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
